import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import ReportItemSessionOverview from "Reporting/Components/ReportItemSessionOverview";

export default function ReportTableSessionOverview({ sessions }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.sessionTitle}>Session</div>
        <div className={styles.attending}>Attending</div>
        <div className={styles.capacity}>Capacity</div>
        <div className={styles.pct}>PCT</div>
      </div>

      {sessions.map((session, index) => (
        <ReportItemSessionOverview
          key={index}
          item={session}
          isOdd={index % 2 !== 0}
        />
      ))}
    </div>
  );
}

ReportTableSessionOverview.propTypes = {
  sessions: PropTypes.array,
};
